module.exports = __webpack_public_path__ + "img/card-bg-01.746f1761.png";